// extracted by mini-css-extract-plugin
module.exports = {"previewImg":"styles_previewImg__3IlIL","fBtn":"styles_fBtn__12gaA","fIcon":"styles_fIcon__3hept"};